/* eslint-disable max-len */
import OgImage from '@propertypal/shared/src/resources/images/prime/prime-og-image.png';
import axios, { API_URL } from '@propertypal/shared/src/services/axios';
import { PrimePricingResponse } from '@propertypal/shared/src/types/prime';
import { IFaqPrimeFaqPrime } from '@propertypal/shared/src/types/strapi';
import platform from '@propertypal/shared/src/utils/platform';
import getPrimeFaqs from '@propertypal/shared/src/utils/prime/getPrimeFaqs';
import PrimeFaqs from '@propertypal/web-ui/src/prime/faq/PrimeFaqs';
import PrimeHeader from '@propertypal/web-ui/src/prime/landing/PrimeHeader';
import { PrimeHeaderContainer } from '@propertypal/web-ui/src/prime/landing/PrimeHeader.style';
import PrimeTiers from '@propertypal/web-ui/src/prime/landing/PrimeTiers';
import WhyPrime from '@propertypal/web-ui/src/prime/landing/WhyPrime';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import React, { FunctionComponent } from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: `Prime | Promote Your Property | ${platform.title}`,
  description: `Prime listings place your home higher in our search and reach more buyers.`,
  url: `/prime`,
  image: {
    url: OgImage.src,
    width: 1200,
    height: 630,
  },
};

interface Props {
  allowMultipleExpanded: boolean;
  faqs: IFaqPrimeFaqPrime[];
  primePricing: PrimePricingResponse;
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { allowMultipleExpanded, faqs } = await getPrimeFaqs(undefined, true);
  const result = await axios<PrimePricingResponse>(
    {
      method: 'GET',
      url: `${API_URL}/premium/pricing/prime`,
    },
    undefined,
    ctx,
  );

  return {
    props: {
      primePricing: result.data,
      allowMultipleExpanded,
      faqs,
    },
  };
};

const Prime: FunctionComponent<Props> = ({ allowMultipleExpanded, faqs, primePricing }) => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <div data-testid="prime-page">
        <PrimeHeaderContainer>
          <PrimeHeader agent />
          <PrimeTiers agent primePricing={primePricing} />
        </PrimeHeaderContainer>
        <WhyPrime />
        <PrimeFaqs faqs={faqs} allowMultipleExpanded={allowMultipleExpanded} agent />
      </div>
    </>
  );
};

export default Prime;
